import React from "react";
import { Route } from "react-router-dom";

import Drafts from "dashboard/containers/Drafts";
import Published from "dashboard/containers/Published";
import BigBoard from "dashboard/containers/BigBoard";
import SearchResults from "dashboard/containers/SearchResults";
import NavigationHeader from "dashboard/containers/NavigationHeader";
import MessagePanel from "components/library/MessagePanel";
import NavigationSidebar from "dashboard/containers/NavigationSidebar";

import styles from "./Dashboard.css";

class Dashboard extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <NavigationSidebar />
        <div className={styles.content}>
          <NavigationHeader />
          <MessagePanel />

          <main className={styles.main}>
            <Route exact path="/dashboard/" component={Drafts} />
            <Route exact path="/dashboard/published" component={Published} />
            <Route exact path="/dashboard/all" component={BigBoard} />
            <Route exact path="/dashboard/search" component={SearchResults} />
          </main>
        </div>
      </div>
    );
  }
}

export default Dashboard;
